<template>
  <div class="m-0">
    <div
    v-if="authStore.roles.includes('viewStaff')"
      @click="showDialog = true"
      class="cursor-pointer mb-3 transition-transform hover:scale-[1.02] flex items-center justify-center gap-1 pl-2 pr-2 text-sm text-white bg-gradient-to-r from-blue-500 to-blue-500 rounded-lg shadow-lg ring-1 ring-red-400/20"
    >
      <i class="pi pi-bell text-2xl"></i>
      <p>You have <span class="font-bold">5</span> pending parent requests.</p>
    </div>
    <OverviewView />
    <Dialog
      v-model:visible="showDialog"
      modal
      :style="{ width: '70vw', position: 'absolute', top: '5vh' }"
      position="top"
    >
      <ParentView />
    </Dialog>
  </div>
</template>

<script setup>
import OverviewView from './OverviewView.vue'
import { ref, onMounted, reactive } from 'vue'
import ParentReview from '@/components/parents/ParentReview.vue'
import ParentView from '@/views/admin/Parents/ParentView.vue'
import { useAuthStore } from '@/auth/auth'
const authStore = useAuthStore()

const showDialog = ref(false)
</script>

<style scoped lang="scss">
.custom {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
